<template>
  <b-overlay :show="loadingStatus">
    <b-list-group class="mw-md-50" flush>
      <b-list-group-item class="d-flex justify-content-between align-items-center">
        {{ $t('monitoramento.resumo.tabs.informacoes.list.tipo') }}
        <b-badge :variant="integration ? 'success' : 'danger'" pill>
          {{ integration.integration_type }}
        </b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-between align-items-center">
        {{ $t('monitoramento.resumo.tabs.informacoes.list.integracao') }}
        <b-badge :variant="integration ? 'success' : 'danger'" pill>
          {{ integration.name }}
        </b-badge>
      </b-list-group-item>
      <div v-if="latestStatus">
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{ $t('monitoramento.resumo.tabs.informacoes.list.impressora') }}
          <b-badge :variant="latestStatus.printer ? 'success' : 'danger'" pill>
            {{ !!latestStatus.printer }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{ $t('monitoramento.resumo.tabs.informacoes.list.sensor') }}
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.temperature_cpu }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{ $t('monitoramento.resumo.tabs.informacoes.list.enviados') }}
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.bytes_sent }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{ $t('monitoramento.resumo.tabs.informacoes.list.recebidos') }}
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.bytes_received }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Debug
          <b-badge :variant="latestStatus.debug ? 'success' : 'danger'" pill>
            {{ !!latestStatus.debug }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Dump
          <b-badge :variant="latestStatus.dump ? 'success' : 'danger'" pill>
            {{ !!latestStatus.dump }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Bridge Version
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.bridge_version }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Transfer Version
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.transfer_version }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Monitor Version
          <b-badge :variant="latestStatus ? 'success' : 'danger'" pill>
            {{ latestStatus.monitor_version }}
          </b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Bridge Service
          <b-badge :variant="latestStatus.exec_line ? 'success' : 'danger'" pill style="white-space: normal !important;">
            {{ latestStatus.exec_line }}
          </b-badge>
        </b-list-group-item>
      </div>
    </b-list-group>
  </b-overlay>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Overview",
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      latestStatus: 'vns/monitor/latestStatus'
    }),
    integration() {
      if (this.vns.integration_destination) return this.vns.integration_destination
      return false
    }
  },
  data() {
    return {
      loadingStatus: false
    }
  },
  methods: {
    ...mapActions([
      'vns/monitor/listStatus',
      'vns/monitor/listLastStatus'
    ])
  },
  async mounted() {
    this.loadingStatus = true
    await this['vns/monitor/listStatus']({
      id: this.vns.id,
      vnsId: this.vns.id,
      minutes: 10
    })
    if (!this.latestStatus) {
      this['vns/monitor/listLastStatus'](this.vns.id)
    }
    this.loadingStatus = false

  }
}
</script>

<style lang="scss" scoped>
.mw-md-50 {
  display: flex;
  margin: auto;
  max-width: 50%;
  @media (max-width: 680px){
    max-width: 100%;
  }
}
</style>